module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.6345f1ab.woff";